import { Box, Container, Typography, Divider, Stack, Link as Link2 } from '@mui/material';
import { styled } from '@mui/material/styles';
import { misc } from 'common/config';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)({
    color: '#FFFFFF',
    fontSize: '16px',
    textDecoration: 'none',
    borderBottom: '2px solid',
    borderColor: '#212121',
    lineHeight: '1.7',
    '&:hover': {
        borderColor: '#FFFFFF',
        color: '#FFFFFF !important'
    }
});

const StyledExternalLink = styled(Link2)({
    color: '#FFFFFF',
    fontSize: '16px',
    textDecoration: 'none',
    borderBottom: '2px solid',
    borderColor: '#212121',
    '&:hover': {
        borderColor: '#FFFFFF',
        color: '#FFFFFF !important'
    }
});

const StyledAnchorLink = styled('a')({
    color: 'white',
    fontSize: '16px',
    textDecoration: 'none',
    borderBottom: '2px solid',
    borderColor: '#212121',
    lineHeight: '1.7',
    '&:hover': {
        borderColor: 'white',
        color: '#FFFFFF !important'
    }
});

const Brand = styled(Typography)({
    color: '#FFFFFF',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '120%',
    marginBottom: '20px'
});

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: 'white',
    [theme.breakpoints.down(1000)]: {
        textAlign: 'center'
    },
    [theme.breakpoints.up(1000)]: {
        textAlign: 'end'
    }
}));

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 0',
    columnGap: 2,
    [theme.breakpoints.down(1000)]: {
        flexDirection: 'column'
    },
    [theme.breakpoints.up(1000)]: {
        flexDirection: 'row'
    }
}));

const StyledBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column'
    },
    [theme.breakpoints.up('sm')]: {
        flexDirection: 'row'
    }
}));

const StyledBox2 = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(1000)]: {
        paddingTop: '20px',
        minWidth: '200px'
    },
    [theme.breakpoints.up(1000)]: {
        paddingTop: '0px',
        minWidth: '400px'
    }
}));

const MainBox = styled(Box)({
    background: '#212121'
});

import Badge from 'assets/images/DigitalBadge.png';

function Footer() {
    return (
        <MainBox data-testid="footer-home-page" id="footer-home-page">
            <Container sx={{ padding: '20px 16px' }}>
                <Box sx={{ display: 'flex', width: '100%' }}>
                    <Box sx={{ flex: 3, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <Brand>IMDA INTEGRATED REGULATORY INFORMATION SYSTEM (IRIS)</Brand>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ padding: '20px 0' }}>
                            <StyledAnchorLink href="https://www.imda.gov.sg/About-IMDA/Who-We-Are">About IMDA</StyledAnchorLink>
                            <StyledLink to="/contact-us">Contact Us</StyledLink>
                            <StyledExternalLink
                                href="https://go.gov.sg/imda-feedback"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                Feedback
                            </StyledExternalLink>
                        </Stack>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'end',
                            justifyContent: 'center',
                            marginBottom: '20px',
                            marginTop: '10px'
                        }}
                    >
                        <img alt="Most popular informational website" src={Badge} width={110} height={110} />
                    </Box>
                </Box>

                <Divider />
                <StyledBox>
                    <Box sx={{ display: 'flex', height: 'max-content', flexWrap: 'wrap', columnGap: { xs: 5, sm: 2 }, rowGap: 2 }}>
                        <StyledBox1 sx={{ columnGap: 2, rowGap: 2 }}>
                            <StyledExternalLink
                                href="https://www.tech.gov.sg/report_vulnerability"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                Report Vulnerability
                            </StyledExternalLink>
                            <StyledLink to="/Supported-Browser">Supported Browser</StyledLink>
                            <StyledLink to="/Privacy-Statement">Privacy Statement</StyledLink>
                        </StyledBox1>
                        <StyledBox1 sx={{ columnGap: 2, rowGap: 2 }}>
                            <StyledLink to="/Terms-of-Use">Terms of Use</StyledLink>
                            <StyledExternalLink href="https://www.reach.gov.sg/" rel="noopener noreferrer" target="_blank">
                                REACH
                            </StyledExternalLink>
                        </StyledBox1>
                    </Box>
                    <StyledBox2 alignItems={{ xs: 'start' }} mb={{ xs: '20px' }}>
                        <StyledTypography sx={{ textAlign: { xs: 'start !important' } }}>
                            © {new Date().getFullYear()}, Infocomm Media Development Authority.
                        </StyledTypography>
                        <StyledTypography>Last updated {misc.REACT_APP_DEPLOYED_TIME}</StyledTypography>
                    </StyledBox2>
                </StyledBox>
            </Container>
        </MainBox>
    );
}

export default Footer;
